import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isSolvPartner } from '../../../core/util/location';
import { createLocationUrlFromLocation } from '../../../core/url/location';
import { BASE_URL } from '../../../config';
import { genCashPrices } from '../Sections/SelfPay/util';
import { isEmptyArray } from '../../../core/util/array';
import { isEmptyString, formatPhone } from '../../../core/util/string';
import {
  getCustomization,
  SCHEMA_ORG_MEDICAL_SPECIALTY,
  SCHEMA_ORG_PAYMENTS_ACCEPTED,
  SCHEMA_ORG_PRICE_RANGE,
  shouldShowFeature,
} from '../util/customization';

class SchemaOrgMainAttributes extends Component {
  constructor(props) {
    super(props);
    const customization = getCustomization(SCHEMA_ORG_MEDICAL_SPECIALTY, {
      location: this.props.location,
    });
    this.medicalSpecialties = customization.value;
  }

  getPaymentAcceptedValue = () => {
    if (!isEmptyArray(this.props.location.acceptedPaymentMethods)) {
      return this.props.location.acceptedPaymentMethods.join(',');
    }

    return 'Cash, Credit Card, PPO';
  };

  getPriceRangeValue = () => {
    const services = genCashPrices(this.props.location.attributes, 'Base Price');
    const prices = services.map(attr => attr.price);
    // 09/04/2018: Returning a default of $100 - $200 after Mike/Rossi/Irit discussion on Slack
    if (isEmptyArray(prices)) {
      return '$100-$200 average base self-pay visit price';
    }

    const maxPrice = Math.max(...prices);
    const minPrice = Math.min(...prices);

    return `$${minPrice}-$${maxPrice} for self-pay patients`;
  };

  render() {
    const {
      location,
      location: { phone, fax, neighborhood, city, state, latLong },
    } = this.props;
    const { brand } = location;
    const { latitude, longitude } = latLong;
    const servedArea = `${neighborhood ? `${neighborhood}, ` : ''} ${city}, ${state}`;
    const amenityFeatureValue = isSolvPartner(location) ? 'Online bookings' : 'Walk-in patients';
    const paymentAcceptedValue = this.getPaymentAcceptedValue();
    const priceRangeValue = this.getPriceRangeValue();
    const alternateName = location.displayNameAlternate;

    return (
      <Fragment>
        {!isEmptyString(alternateName) && <meta itemProp="alternateName" content={alternateName} />}
        {!isEmptyArray(this.medicalSpecialties) && (
          <meta itemProp="medicalSpecialty" content={this.medicalSpecialties} />
        )}
        {brand && (
          <span itemScope itemType="https://health-lifesci.schema.org/Brand">
            {brand.name && <meta itemProp="name" content={brand.name} />}
            {brand.logo && <meta itemProp="logo" content={brand.logo} />}
            {brand.url && <meta itemProp="url" content={brand.url} />}
          </span>
        )}
        {phone && <meta itemProp="telephone" content={formatPhone(phone)} />}
        {fax && <meta itemProp="faxNumber" content={fax} />}
        <meta itemProp="areaServed" content={servedArea} />
        <span itemScope itemProp="geo" itemType="https://health-lifesci.schema.org/GeoCoordinates">
          <meta itemProp="latitude" content={latitude} />
          <meta itemProp="latitude" content={longitude} />
        </span>
        <meta itemProp="url" content={`${BASE_URL}${createLocationUrlFromLocation(location)}`} />
        <meta itemProp="amenityFeature" content={amenityFeatureValue} />
        {shouldShowFeature(SCHEMA_ORG_PAYMENTS_ACCEPTED, location) && (
          <meta itemProp="paymentAccepted" content={paymentAcceptedValue} />
        )}
        <meta itemProp="currenciesAccepted" content="USD" />
        {shouldShowFeature(SCHEMA_ORG_PRICE_RANGE, location) && priceRangeValue && (
          <meta itemProp="priceRange" content={priceRangeValue} />
        )}
      </Fragment>
    );
  }
}

SchemaOrgMainAttributes.propTypes = {
  location: PropTypes.object.isRequired,
};

export default SchemaOrgMainAttributes;
